
import Vue from 'vue'
import VueKonva from 'vue-konva'
import { v4 as uuid } from 'uuid'
import { mapGetters } from 'vuex'



interface Container {
  id: string,
  x: number,
  y: number,
  width: number,
  height: number,
  fill: string,
  stroke: string,
  strokeWidth: number,
  type: string
}

export default Vue.extend({
  props: {
    minDeckTiers:{default: 0},
    data: {
      default: {
        cols: 4,
        rows: 4,
        cells: [{ existed: true, isReefer: true, is45Foot: false }],
      }
    },
    name: {
      default: 'Bay 01',
      type: String
    },
    selectedContainerType: {
      default: 'standard',
    },
    mirrorMode: {
      default: ''
    }
  },
  data() {
    return {
      ctrlKey: false,
      selectedCells: [],
      CELL_WIDTH: 40,
      reeferImage: process.env.VUE_APP_BASE_URL + "media/svg/vesselProfile/Reefer.svg",
      // containers: this.data.cells.map((c, index) => ({ ...c, id: uuid(), x: (index % this.data.cols) * 30 + 50, y: (index % this.data.rows) * 30 + 5, width: 30, height: 30, fill: 'gray', stroke: 'black', strokeWdith: 0.5, type: 'standard' })),

      textConfig: {
        fontSize: 10,
        fill: '#D0D0D0'
      },
      // @ts-ignore

      // Array(this.cols).fill().map((_, i) => Array(this.cols).fill().map((_, j) => ({
      //   id: `${i}-${j}`,
      //   x: 50 + j * 40,
      //   y: 40 + i * 40,
      //   width: 40,
      //   height: 40,
      //   fill: 'gray',
      //   stroke: 'black',
      //   strokeWidth: 0.5,
      //   draggable: false,
      //   type: 'standard'
      // } as Container))).flat()
    }
  },
  methods: {
    reeferConfig(container) {
      return {
        x: container.x,
        y: container.y,
        listening: false,
        // width: this.CELL_WIDTH,
        width: (() => {
          return this.CELL_WIDTH
        })(),
        height: this.CELL_WIDTH,
        //image: this.reeferImage,
      }
    },
    getXLabels() {
      let labels = []
      let middle = this.data.cols % 2 === 0 ? this.data.cols / 2 : Math.floor(this.data.cols / 2)
      let startNumber = this.data.cols % 2 === 0 ? 1 : 0
      for (let i = 0; i < this.data.cols; i++) {
        if (this.data.cols % 2 === 0) {
          labels[middle + Math.floor((i * ((-1) ** i)) / 2)] = (i + 1).toString().padStart(2, '0')
        } else {
          labels[middle + Math.ceil((i * ((-1) ** (i - 1))) / 2)] = (startNumber + i).toString().padStart(2, '0')
        }
      }
      return labels
    },
    getYLabels() {
      let labels = []
      for (let i = this.data.rows - 1; i >= 0; i--) {
        labels.push((this.minDeckTiers + i * 2).toString())
      }
      return labels
    },
    getXLabelConfig(value: string, index: number) {
      return {
        text: value,
        x: 5 + index * this.CELL_WIDTH,
        y: 5,
        fontSize: 11,
        listening: false,
        fill: '#707070'
      }
    },
    getYLabelConfig(value: string, index: number) {
      return {
        text: value.toString(),
        x: this.data.cols * this.CELL_WIDTH + 5,
        y: 5 + this.CELL_WIDTH + index * this.CELL_WIDTH,
        fontSize: 11,
        listening: false,
        fill: '#707070'
      }
    },
    
    
    convertKey(value) {
      switch (value) {
        case "standard":
          return "existed"
        case "reefer":
          return "isReefer"
        case "45foot":
          return "is45Foot"
        default:
        return ""
      }
    },
  },
  computed: {
    ...mapGetters({
      selectedHatchData: 'getSelectedHatchData',
      selectedHatchIndex: 'getSelectedHatchIndex',
    }),
    configKonva() {
      return {
        width: 0 + this.data.cols * this.CELL_WIDTH,
        height: this.data.rows * this.CELL_WIDTH + 25
      }
    },

    containers() {
      const thisComponentRef = this
      const cols = this.data.cols
      const rows = this.data.rows
      let stroke = '#A0A0A0'
      let hoverStroke = '#000000'
      let strokeWidth = 0.3
      let hoverStrokeWidth = 1
      // Add properties neeeded for ui
      const newContainers = this.data.cells.map((c, index) => {

        let cellData = {
          ...c,
          id: uuid(),
          index: index,
          x: ((index % cols)) * this.CELL_WIDTH,
          y: (rows - 1 - Math.floor(index / cols)) * this.CELL_WIDTH + 20,
          width: this.CELL_WIDTH,
          height: this.CELL_WIDTH,
          fill: c.existed ? '#5B646B' : 'white',
          stroke: '#A0A0A0',
          strokeWidth: 0.3,
          type: 'standard',
          
          onmousedown(evt) {
            if (thisComponentRef.ctrlKey)
              thisComponentRef.selectCell(index)
            else
              thisComponentRef.handleClick(index, c, true)
          },
          onmouseup(evt) {
            thisComponentRef.EndSelectedIndexCell = index
            if (thisComponentRef.ctrlKey)
              thisComponentRef.colorAndSelectCell()
          },
          onmouseover(evt) {
              const shape = evt.target
              shape.stroke(hoverStroke)
              shape.strokeWidth(hoverStrokeWidth)
              document.body.style.cursor = 'pointer'            
          },
          onmouseout(evt) {
            const shape = evt.target
            document.body.style.cursor = 'default'
            shape.stroke(stroke)
            shape.strokeWidth(strokeWidth)
          },
        }
        return cellData;
      })
      return newContainers
    },
    tester() {
    }
  },
  mounted() {
    const reeferImage = new window.Image()
    reeferImage.src = 'media/svg/vesselProfile/Reefer.svg'
    reeferImage.onload = () => {
      // set image only when it is loaded
     // this.reeferImage = reeferImage
    }
  },
  created() {
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keyup', this.onkeyup);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keyup', this.onkeyup);
  },
})
